<router-outlet></router-outlet>

<!-- Named outlet for modals -->
<router-outlet name="modal"></router-outlet>